import logo from '../../../assets/imgs/brda_logo_light_vertical.svg';
import Constants from '../../../utils/Constants';

const About = () => {
  return (
    <div id={Constants.ABOUT} className='about'>
      <div className='about_container container'>
        <div className='about_container_logo'>
          <div
            data-aos='fade-up'
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <img src={logo} alt={Constants.PROPERTY_NAME + ' large logo'} />
          </div>
        </div>
        <div className='about_container_text'>
          <h2 data-aos='fade-up' className='title_underline_light'>
            BRDA PROJEKT
          </h2>
          <p data-aos='fade-up' data-aos-delay='50'>
            Započela je gradnja stambeno-poslovnog objekta PROJEKT BRDA na
            mirnoj lokaciji istoimenog kvarta koji će biti okružen zelenilom te
            će se njome dolaziti lokalnom pritupnom cestom.
          </p>
          <p data-aos='fade-up' data-aos-delay='100'>
            Idealna pozicija stanova omogućava dostupnost svim sadržajima -
            školi, vrtiću, tržnica, zelenim površinama, šetnicama, trgovačkim
            centrima, ambulanti i ostalim sadržajima koji vaš život mogu učiniti
            lakšim, dinamičnijim i uzbudljivijim.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
